import { Mk2Response, Pagination } from '@lsq-frontend/angular-shared/api-service';
import { BuyerPaymentsSummaryItem } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/buyer-payments-summary-item';
import { BuyerPaymentsDetailItem2 } from '../../../model/models';

export class BuyerPaymentsDetailResponsePayLater extends Mk2Response {
    buyerLegalName?: string;
    buyerPaymentsSummaryItem?: BuyerPaymentsSummaryItem;
    groupedChildSearchMatchKeyList?: string[];
    pagination?: Pagination;
    rows?: BuyerPaymentsDetailItem2[];
    searchValue?: string;
    totalCount?: number;

    constructor(initial?: Partial<BuyerPaymentsDetailResponsePayLater>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}
